import React from "react";
import * as styles from "./button_orange.module.scss";

interface IButton {
  variant?: "primary" | "outline";
  size?: "big" | "small";
  type?: "link" | "button" | "submit";
  text?: string;
  icon?: "arrow" | "human";
  href?: string;
  target?: "_blank" | "_self" | "_parent" | "_top";
  onClick?: () => void;
  style?: string;
  disabled?: boolean;
}

const ButtonOrange: React.FC<IButton> = ({ variant = "primary", size = "big", type = "link", text = "Book a demo", icon, href = "/demo/", target = "_self", onClick, style, disabled = false }) => {
  const renderIcon = () => {
    switch (icon) {
      case "arrow":
        return (
          <span className={styles.icon}>
            <Arrow />
          </span>
        );
      case "human":
        return (
          <span className={styles.icon}>
            <User />
          </span>
        );
      default:
        return null;
    }
  };

  const content = (
    <>
      {text && <span className={styles.text}>{text}</span>}
      {icon && renderIcon()}
    </>
  );

  const classNames = `${styles.btn} ${styles[variant]} ${size === "small" ? styles.small : ""}`;

  if (type === "link") {
    return (
      <a href={href} target={target} className={`${classNames} ${style}`}>
        {content}
      </a>
    );
  }

  return (
    <button type={type} onClick={onClick} className={`${classNames} ${style}`} disabled={disabled}>
      {content}
    </button>
  );
};

export default ButtonOrange;

const Arrow = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.508838 13.0378C6.62333 13.2889 10.6468 13.5427 15.899 13.2603C21.1512 12.978 19.6848 11.9193 18.2999 11.1222C15.7463 9.65255 12.8926 8.24458 11.7409 6.70328C10.256 4.71622 21.8757 11.075 22.8746 12.1003C22.5624 15.2394 16.381 14.4441 16.0678 15.4439C15.91 15.9476 15.7546 16.4438 15.5944 16.955"
      stroke="currentColor"
      strokeLinecap="round"
    />
  </svg>
);

const User = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.3334 14V12.6667C13.3334 11.9594 13.0525 11.2811 12.5524 10.781C12.0523 10.281 11.374 10 10.6667 10H5.33341C4.62617 10 3.94789 10.281 3.4478 10.781C2.9477 11.2811 2.66675 11.9594 2.66675 12.6667V14"
      stroke="white"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.99992 7.33333C9.47268 7.33333 10.6666 6.13943 10.6666 4.66667C10.6666 3.19391 9.47268 2 7.99992 2C6.52716 2 5.33325 3.19391 5.33325 4.66667C5.33325 6.13943 6.52716 7.33333 7.99992 7.33333Z"
      stroke="white"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
